import "@shared/assets/styles/common.css"
import "@shared/assets/styles/vod.common.custom.css"
import "@shared/assets/styles/vod_common.css"

import React from "react"

import { MetaData } from "@shared/components"
// import { Notice } from "@shared/components/layerPopups"
import { LayerPopupProvider } from "@shared/contexts"
import { ChatProvider } from "@shared/contexts"
import { ScheduleProvider } from "@shared/contexts"

// import { useAppierVodEvent, useCriteo, useCRM } from "@shared/hooks"
import { Shorts } from "shorts/components"
import { VodPlayerProvider, VodsProvider } from "vod/contexts"

// 숏폼 페이지는 VODS 페이지 그대로 가져와서 몇개 기능 없앤 페이지입니다.
// UI만 똑같이 가라는 마케팅팀의 요구가 있었음.
// 그에 따라 몇가지 로직이 주석 처리 되었습니다.
function ShortsPage() {
  // 숏폼 관련 마케팅에서 쓰이는 값 로직은 추후 추가 예정. -> 아직 해당 사항 없었음
  // useCriteo()
  // useCRM()
  // useAppierVodEvent()

  return (
    <LayerPopupProvider>
      <ChatProvider>
        {/* <Notice targetPlayer="VOD" /> */}
        {/* Notice 관련 코드가 VOD에 있으나, 숏폼에 들어가야 하는 요구사항은 없어서 주석 처리 */}
        <MetaData />
        <VodsProvider>
          <VodPlayerProvider>
            <Shorts />
          </VodPlayerProvider>
        </VodsProvider>
      </ChatProvider>
    </LayerPopupProvider>
  )
}

export default () => (
  <ScheduleProvider isDetect={false}>
    <ShortsPage />
  </ScheduleProvider>
)
